module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/383.6eba9044.png";